import {
	checkCircleBoxContainerSx,
	checkCircleBoxIconSx,
} from '@/components/blocks/ProductDetails/styles/checkCircleBox';
import { CheckCircle } from '@mui/icons-material';
import { Box } from '@mui/material';
import { FC } from 'react';

interface CheckCircleBoxProps {
	isMobile: boolean;
}

export const CheckCircleBox: FC<CheckCircleBoxProps> = ({ isMobile }) => (
	<Box sx={checkCircleBoxContainerSx({ isMobile })}>
		<CheckCircle sx={checkCircleBoxIconSx({ isMobile })} />
	</Box>
);
